import React from "react";
import { useNavigate } from "react-router-dom";
import IndusIndLogo from "../../assets/BankLogo/indusland.png";
import AxisLogo from "../../assets/BankLogo/axis.png";
import HDFCLogo from "../../assets/BankLogo/hdfc.png";
import IDFCLogo from "../../assets/BankLogo/idfc.png";


const DoctorLoanBankOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "doctor",
      title: "Doctor Loan",
    },
  ];

  const loanData = [
    {
      loanType: "Doctor Loan",
      bank: "IndusInd Bank",
      loanAmount: "₹10 L to ₹10 Cr",
      interestRate: "Starting @ 11%",
      tenure: "Up to 7 Years",
      tag: "Real Time Offer",
      bankLogo: IndusIndLogo
    },
    {
      loanType: "Doctor Loan",
      bank: "Axis Bank",
      loanAmount: "₹10 L to ₹5 Cr",
      interestRate: "Starting @ 9.5%",
      tenure: "10 to 20 Years",
      tag: "Real Time Offer",
      bankLogo: AxisLogo
    },
    {
      loanType: "Doctor Loan",
      bank: "IDFC",
      loanAmount: "₹10 L to ₹1 Cr",
      interestRate: "Starting @ 11%",
      tenure: "Up to 84 Months",
      tag: "Real Time Offer",
      bankLogo: IDFCLogo
    },
    {
      loanType: "Doctor Loan",
      bank: "HDFC",
      loanAmount: "₹10 L to ₹75 L",
      interestRate: "Starting @ 11.75%",
      tenure: "Up to 72 Months",
      tag: "Real Time Offer",
      bankLogo: HDFCLogo
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  return (
    <div className="pricing-main-container">
      <h4 className="bank-offer-title">{loanData[0].loanType}</h4>
      <p className="bank-offer-description">
        “Doctors with a {" "}
        <span className="highlight-rate">net monthly salary above ₹70,000.</span>
        <br /> Those owning a clinic with an{" "}
        <span className="highlight-rate">
          annual turnover above ₹1 crore can apply here.</span>”
        <br />(Minimum 5 years of service after MBBS is required.)
      </p>
      <div className="pricing-cards">
        {loanData.map((loan, index) => (
          <div key={index} className="pricing-card">
            <div className="bank-header">
              <img src={loan.bankLogo} alt={loan.bank} className="bank-logo" />
              <h3 className="bank-name">{loan.bank}</h3>
            </div>
            <p>
              <strong>Loan Amount:</strong> {loan.loanAmount}
            </p>
            <p>
              <strong>Interest Rate:</strong> {loan.interestRate}
            </p>
            <p>
              <strong>Tenure:</strong> {loan.tenure}
            </p>
            <p className="offer-tag">{loan.tag}</p>
            {plans.map((plan, index) => (
              <button
                className="apply-button"
                key={index}
                onClick={() => handleApplyClick(plan.loanType)}
              >
                Check Eligibility
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
export default DoctorLoanBankOffer;
